import React, {useEffect, useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";

const OpenInMobilePage = () => {
    const {t} = useTranslation("common");
    const navigate = useNavigate();
    const location = useLocation();

    // Extract query parameters from the URL
    const queryParams = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return {
            action: searchParams.get('action') || 'camera',
            patientId: searchParams.get('patientId'),
            token: searchParams.get('token')
        };
    }, [location.search]);

    // Construct the deeplink with the query parameters
    const deeplink = useMemo(() => {
        let link = "glacies://app?action=" + queryParams.action;
        if (queryParams.patientId) link += "&patientId=" + queryParams.patientId;
        if (queryParams.token) link += "&token=" + queryParams.token;
        return link;
    }, [queryParams]);

    useEffect(() => {
        // Attempt to open the deeplink when component mounts
        window.location.href = deeplink;

        // Set a fallback timer to redirect if deeplink fails
        const fallbackTimeout = setTimeout(() => {
            navigate("/"); // Redirect to home or another appropriate page
        }, 3000);

        return () => clearTimeout(fallbackTimeout);
    }, [navigate, deeplink]);

    return (
        <div className="open-in-mobile-container">
            <h1>{t("openInMobile.title")}</h1>
            <p>{t("openInMobile.redirecting")}</p>
            <p>{t("openInMobile.fallback")}</p>
            <button
                onClick={() => window.location.href = deeplink}
                className="retry-button"
            >
                {t("openInMobile.openManually")}
            </button>
        </div>
    );
};

export default OpenInMobilePage;